import React from 'react';
import { Box } from '../../../../../components/Box';
import Text from '../../../../../components/Text';
import { RenderSeparatedName } from '../../../../../utils/string';
import { countries } from '../../../../editor/countries/countries';
import { useFormDataContext } from '../../../contexts/form-data.ctx';
import { Input } from '../../Input';

function Mutator({ documentId, name, label = 'Select', ...rest }) {
  const values = useFormDataContext(({ data, setField }) => ({
    value: data[name] || {},
    setField,
  }));

  const [fieldValues, setFieldValues] = React.useState(values);

  const handleChange = async () => {
    await values.setField({
      target: {
        name,
        value: fieldValues.value,
      },
    });
  };

  const changeValue = (data, key) => {
    if (!fieldValues.value[documentId]) {
      fieldValues.value[documentId] = {};
    }
    let valuesCopy = JSON.parse(JSON.stringify(fieldValues));
    valuesCopy.value[documentId][key] = data;
    setFieldValues(valuesCopy);
  };

  return (
    <>
      {fieldValues && fieldValues.value && (
        <>

        </>
      )}
    </>
  );
}

function HTMLRenderer(values, documentId, parentDocumentId) {
  let returnValue = '';
  const htmlParser = new DOMParser();
  const virtualHTML = document.createElement('div');
  const getSpolocnik = (id) => {
    if (values.company && values.company.spolocnici) {
      for (let spolocnik of values.company.spolocnici) {
        if (spolocnik.id === id) {
          return spolocnik
        }
      }
    }
  }
  if (
    values &&
    values['prevod_podielu_custom'] &&
    values['prevod_podielu_custom'][parentDocumentId] &&
    values.company && values.company.spolocnici
  ) {
    let person = values['prevod_podielu_custom'][parentDocumentId]
    let newOwner = person.newOwner
    let spolocnik = getSpolocnik(person.owner);

    returnValue += `<div style="display: flex; justify-content: space-between">`
    returnValue += "<div>"
    returnValue += `<h4>Prevodca:</br></h4>`;

    if (spolocnik.type === 'ownerPerson') {
      returnValue += `<h4> </h4><p class="ql-align-left">V ......................., dňa ...........................<p style="color: rgb(255, 255, 255);">[[SH-TR-IMAGE-PL-${RenderSeparatedName(spolocnik.personName)}]]</p></br></br></p>`;
      returnValue += `<p class="ql-align-left">..........................................</br>${RenderSeparatedName(spolocnik.personName)}</p>`;
      returnValue += `<p class="ql-align-left">(úradne osvedčený podpis)</br></p>`;
      returnValue += "</br>"


    } else {
      if (person && person.representingPersons) {
        let representingPersonIndex = 0
        for (let representingPerson of person.representingPersons) {
          let representingPersonName = `<span class="mention" data-denotation-char=":" data-id="representing-person-name-${representingPersonIndex}" name="representing-person-name" data-value="Titul, meno priezvisko">&#xFEFF;<span contenteditable="false"><span class="ql-mention-denotation-char">:</span>Titul, meno priezvisko</span>&#xFEFF;</span>`
          let representingPersonFunction = `<span class="mention" data-denotation-char=":" data-id="representing-person-function-${representingPersonIndex}" name="representing-person-function" data-value="Funkcia">&#xFEFF;<span contenteditable="false"><span class="ql-mention-denotation-char">:</span>Funkcia</span>&#xFEFF;</span>`
          returnValue += `<h4> </h4><p class="ql-align-left">V ......................., dňa ...........................<p style="color: rgb(255, 255, 255);">[[SH-TR-IMAGE-PL-${representingPerson.name}]]</p></br></br></p>`;
          returnValue += `<p class="ql-align-left">..........................................</br>${spolocnik.fullName}</p>`;
          returnValue += `<p class="ql-align-left">${representingPersonName}, ${representingPersonFunction}</br></p>`;
          returnValue += `<p class="ql-align-left">(úradne osvedčený podpis)</br></p>`;
          returnValue += "</br></br>"
          representingPersonIndex += 1
        }
      }
    }
    returnValue += "</div>"
    returnValue += "<div>"
    returnValue += `<h4>Nadobúdateľ:</br></h4>`;
    if (newOwner.type === 'ownerPerson') {
      returnValue += `<h4> </h4><p class="ql-align-left">V ......................., dňa ...........................<p style="color: rgb(255, 255, 255);">[[SH-TR-IMAGE-PL-${newOwner.separatedName ? RenderSeparatedName(newOwner.separatedName) : "[Doplňte]"}]]</p></br></br></p>`;
      returnValue += `<p class="ql-align-left">..........................................</br>${newOwner.separatedName ? RenderSeparatedName(newOwner.separatedName) : "[Doplňte]"}</p>`;
      returnValue += `<p class="ql-align-left">(úradne osvedčený podpis)</br></p>`;
      returnValue += "</br>"


    } else {
      if (newOwner && newOwner.representingPersons) {
        let representingPersonIndex = 0
        for (let representingPerson of newOwner.representingPersons) {
          let representingPersonName = `<span class="mention" data-denotation-char=":" data-id="new-representing-person-name-${representingPersonIndex}" name="new-representing-person-name" data-value="Titul, meno priezvisko">&#xFEFF;<span contenteditable="false"><span class="ql-mention-denotation-char">:</span>Titul, meno priezvisko</span>&#xFEFF;</span>`
          let representingPersonFunction = `<span class="mention" data-denotation-char=":" data-id="new-representing-person-function-${representingPersonIndex}" name="new-representing-person-function" data-value="Funkcia">&#xFEFF;<span contenteditable="false"><span class="ql-mention-denotation-char">:</span>Funkcia</span>&#xFEFF;</span>`
          returnValue += `<h4> </h4><p class="ql-align-left">V ......................., dňa ...........................<p style="color: rgb(255, 255, 255);">[[SH-TR-IMAGE-PL-${representingPerson.name}]]</p></br></br></p>`;
          returnValue += `<p class="ql-align-left">..........................................</br>${newOwner.name ? newOwner.name : "[Doplňte]"}</p>`;
          returnValue += `<p class="ql-align-left">${representingPersonName}, ${representingPersonFunction}</br></p>`;
          returnValue += `<p class="ql-align-left">(úradne osvedčený podpis)</br></p>`;
          returnValue += "</br></br>"
          representingPersonIndex += 1
        }
      }
    }
    returnValue += "</div>"
    returnValue += "</div>"

    virtualHTML.append(htmlParser.parseFromString(returnValue, 'text/html').body);

    virtualHTML.querySelectorAll('.mention').forEach((artifact) => {
      const key = artifact.getAttribute('name');
      if (
        values['prevod_podielu_custom'] &&
        values['prevod_podielu_custom'][parentDocumentId]
      ) {
        let dataId = artifact.getAttribute('data-id');
        switch (key) {
          case 'representing-person-name': {
            if (dataId.indexOf('representing-person-name') !== -1) {
              let data = dataId.split('-');
              let index = Number(data[data.length - 1]);
              if (
                values['prevod_podielu_custom'][parentDocumentId].representingPersons && values['prevod_podielu_custom'][parentDocumentId].representingPersons[index] && values['prevod_podielu_custom'][parentDocumentId].representingPersons[index].name
              ) {
                artifact.innerHTML = values['prevod_podielu_custom'][parentDocumentId].representingPersons[index].name;
              }
            }
            break;
          }
          case 'representing-person-function': {
            if (dataId.indexOf('representing-person-function') !== -1) {
              let data = dataId.split('-');
              let index = Number(data[data.length - 1]);
              if (
                values['prevod_podielu_custom'][parentDocumentId].representingPersons && values['prevod_podielu_custom'][parentDocumentId].representingPersons[index] && values['prevod_podielu_custom'][parentDocumentId].representingPersons[index].function
              ) {
                artifact.innerHTML = values['prevod_podielu_custom'][parentDocumentId].representingPersons[index].function;
              }
            }
            break;
          }
          case 'new-representing-person-name': {
            if (dataId.indexOf('representing-person-name') !== -1) {
              let data = dataId.split('-');
              let index = Number(data[data.length - 1]);
              if (
                values['prevod_podielu_custom'][parentDocumentId].newOwner.representingPersons && values['prevod_podielu_custom'][parentDocumentId].newOwner.representingPersons[index] && values['prevod_podielu_custom'][parentDocumentId].newOwner.representingPersons[index].name
              ) {
                artifact.innerHTML = values['prevod_podielu_custom'][parentDocumentId].newOwner.representingPersons[index].name;
              }
            }
            break;
          }
          case 'new-representing-person-function': {
            if (dataId.indexOf('representing-person-function') !== -1) {
              let data = dataId.split('-');
              let index = Number(data[data.length - 1]);
              if (
                values['prevod_podielu_custom'][parentDocumentId].newOwner.representingPersons && values['prevod_podielu_custom'][parentDocumentId].newOwner.representingPersons[index] && values['prevod_podielu_custom'][parentDocumentId].newOwner.representingPersons[index].function
              ) {
                artifact.innerHTML = values['prevod_podielu_custom'][parentDocumentId].newOwner.representingPersons[index].function;
              }
            }
            break;
          }
          default: {
            if (dataId.indexOf('newOwner') !== -1) {
              let data = dataId.split('-');
              let index = Number(data[data.length - 1]);
              if (
                values['prevod_podielu_custom'][parentDocumentId].newOwner[key]
              ) {
                artifact.innerHTML = `${values['prevod_podielu_custom'][parentDocumentId].newOwner[key]}`;
              }
            } else {
              if (values['prevod_podielu_custom'][parentDocumentId][key] && values['prevod_podielu_custom'][parentDocumentId][key] !== "Invalid date") {
                artifact.innerHTML =
                  values['prevod_podielu_custom'][parentDocumentId][key];
              }
            }
          }
        }
      }
    });

  }
  return returnValue === ''
    ? '[PREVOD-PODIELU-TRANSFER-SIGNATURE]'
    : virtualHTML.innerHTML;
}

const ShareTransferSignature = {
  Mutator,
  HTMLRenderer,
};

export default ShareTransferSignature;
